import { ChangeDetectionStrategy, Component, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { Coerce } from '@kalidea/kaligraphi';

@Component({
    selector: 'app-button-close',
    template: `
      <div class="gup-C-buttonClose">
          <kal-icon>close</kal-icon>
      </div>
  `,
    styleUrls: ['./button-close.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ButtonCloseComponent {

    @Input()
    @Coerce('boolean')
    back;

    @HostListener('click')
    goBack() {
        if (this.back) {
            window.history.back();
        }
    }

}
